'use strict';

var coreUtilityAliases = require('../var/coreUtilityAliases');

var classToString = coreUtilityAliases.classToString;

function isClass(obj, className, str) {
  if (!str) {
    str = classToString(obj);
  }
  return str === '[object '+ className +']';
}

module.exports = isClass;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/isClass.js
// module id = 562
// module chunks = 0